"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{NumberField as m}from"./src/NumberField.js";e("sp-number-field",m);
//# sourceMappingURL=sp-number-field.js.map
